<template>
    <div class="list-schedule">

        <!-- Tabs -->
        <tabs class="nav-dates" v-if="isNotEmpty" @onClick="tabSelected($event)">

            <!-- Unchedule Tab -->
            <tab id="unscheduled"
                 v-if="ownsList"
                 :name="(unscheduleSpots.length ? `Unscheduled (${unscheduleSpots.length})` : 'Unscheduled')"
                 :selected="isTabSelected('unscheduled')">

                <template v-for="(schedule, index) in unscheduleSpots">
                    <SpotBadge :index="index"
                               :list="currentList"
                               :tooltips="tooltips"
                               current-tab="unscheduled"
                               :schedule="schedule">
                    </SpotBadge>
                </template>

                <div v-if="unscheduleSpots.length == 0 && !showAddSpotToListBtn" class="no-plans-yet">
                    <p>All spots have been scheduled!</p>
                </div>

            </tab>

            <!-- Days -->
            <tab  v-for="(schedules, date, index) in scheduleDates"
                  :key="`day-${index + 1}`"
                  :id="`day-${index + 1}`"
                  :name="date"
                  :selected="isTabSelected(`tab-${index + 1}`, (!ownsList && index == 0))">

                <draggable v-if="scheduleDates[date].length > 0"
                           v-model="scheduleDates[date]"
                           :group="`tab-${index}`"
                           handle=".spot-badge-draggable-trigger"
                           filter=".ignore-elements"
                           :delay="150"
                           :delayOnTouchOnly="true"
                           :disabled="(!ownsList || scheduleDates[date].length <= 1)"
                           @change="draggedSpot($event)">

                    <template v-for="(schedule, sIndex) in scheduleDates[date]">

                        <SpotBadge :key="`spot-badge-${schedule.id}`"
                                   :list="currentList"
                                   :current-tab="`tab-${index}`"
                                   :schedule="schedule">
                        </SpotBadge>

                    </template>

                </draggable>

                <div v-else-if="!showAddSpotToListBtn" class="no-plans-yet">
                    <p>No plans for this day yet!</p>
                </div>

            </tab>

            <!-- Unchedule Tab -->
            <tab id="unscheduled"
                 v-if="!ownsList"
                 :name="(unscheduleSpots.length ? `Unscheduled (${unscheduleSpots.length})` : 'Unscheduled')"
                 :selected="isTabSelected('unscheduled', false)">

                <template v-for="(schedule, index) in unscheduleSpots">
                    <SpotBadge :index="index"
                               :list="currentList"
                               :tooltips="tooltips"
                               current-tab="unscheduled"
                               :schedule="schedule">
                    </SpotBadge>
                </template>

                <div v-if="unscheduleSpots.length == 0 && !showAddSpotToListBtn" class="no-plans-yet">
                    <p>All spots have been scheduled!</p>
                </div>

            </tab>

        </tabs>

        <EmptyListCta v-else-if="Object.keys(scheduleDates).length == 0"></EmptyListCta>

        <div class="map-list wrapper" v-if="showAddSpotToListBtn">
            <div class="no-spots-container">

                <div class="trip-img">
                    <svg class="trip"><use xlink:href="#trip"></use></svg>
                </div>

                <p>Add your first spot to the List!</p>

                <button class="add-spot-btn" @click="addSpotToList()">
                    <svg class="plus"><use xlink:href="#plus"></use></svg>
                </button>

            </div>
        </div>

    </div>
</template>
<script>

import Draggable from 'vuedraggable'
import Tab from '@/components/Tab'
import Tabs from '@/components/Tabs'
import EmptyListCta from './EmptyListCta'
import SpotBadge from './SpotBadge'

export default {

    props: ['list', 'tooltips'],

    components: {
        Tabs,
        Tab,
        EmptyListCta,
        SpotBadge,
        Draggable
    },

    data() {
        return {
            arrayI: ['1', '2', '3'],
            currentTab: null,
            currentList: this.list,
            unscheduleSpots: [],
            scheduleDates: {},
        }
    },

    created() {
        this.fetchSchedules()
        eventBus.$on('fetch-schedule', this.fetchSchedules)
    },

    methods: {

        isTabSelected(tabId, _default = true) {
            return this.currentTab ? (this.currentTab == tabId) : _default
        },

        fetchSchedules(data) {

            console.log('fetch schedules');

            this.currentTab = null

            if (data && data.hasOwnProperty('tab')) {
                this.currentTab = data.tab
            }

            axios.get(`/lists/${this.currentList.id}/schedules`)
                .then(response => {

                    eventBus.$emit('schedule-updated', response.data)

                    this.unscheduleSpots = []
                    this.scheduleDates = {}

                    this.$nextTick(() => {
                        if (response.data.is_schedule_available) {
                            this.unscheduleSpots = _.map(response.data.unscheduled_spots, spot => {
                                return {spot: spot}
                            })
                            this.scheduleDates = response.data.schedule_dates;
                        }
                    })
                })
                .catch(errors => {
                    //
                })
        },

        draggedSpot(event) {
            let schedule = event.moved.element;
            let spot = event.moved.element.spot;
            let order = event.moved.newIndex + 1;

            axios.patch(`/lists/${this.currentList.id}/schedules/${spot.slug}`, {
                day: schedule.day,
                order: order,
            })
                .then(response => {
                    console.log('OK')
                })
        },

        addSpotToList() {

            eventBus.$emit('add-a-spot-to-list')
        },

        tabSelected(event) {
            let data = []
            if (typeof event.current == "string" && event.current.includes("day-")) {
                let index = event.current.split("-")[1] - 1
                let schedules = Object.values(this.scheduleDates);
                if (schedules[index]) {
                    data = _.map(schedules[index], schedule => schedule.spot)
                }
            } else if (event.current.$props) {
                let day = event.current.$props.name
                if (this.scheduleDates[day]) {
                    data = _.map(this.scheduleDates[day], schedule => schedule.spot)
                } else if (event.current.$props.id == "unscheduled") {
                    data = _.map(this.unscheduleSpots, schedule => schedule.spot)
                }
            }
            eventBus.$emit('gotSpots', {
                spots: data,
                autofocus: true
            });
        }
    },

    watch: {
        list: {
            deep: true,
            handler() {
                {
                    this.currentList = this.list
                    this.fetchSchedules()
                }
            }
        }
    },

    computed: {

        showAddSpotToListBtn(){
            if(this.ownsList && this.unscheduleSpots.length == 0) {
                for (let date in this.scheduleDates) {
                    if (this.scheduleDates[date].length) {
                        return false;
                    }
                }
                return true;
            }

            return false;
        },

        isNotEmpty() {
            return (this.unscheduleSpots.length || Object.keys(this.scheduleDates).length)
        },

        ownsList() {
            return window.config.isLoggedIn && window.config.user.id == this.currentList.user_id;
        },

        isTouchDevice() {
            return ('ontouchstart' in window || navigator.msMaxTouchPoints);
        },
    }
}
</script>
